// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--rLNBC";
export var logo = "Footer-module--logo--WSN3h";
export var text = "Footer-module--text--olO+3";
export var copy = "Footer-module--copy--HSXlw";